import React from "react";
import { Wrapper } from "./styled";
import ContributorForm from "./components/ContributorForm";
import PayerForm from "./components/PayerForm";
import Button from "./components/Button";

const Form = () => {
  return (
    <Wrapper>
      <ContributorForm />
      <PayerForm />
      <Button />
    </Wrapper>
  );
};

export default Form;
